import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; // Correct way in React Router v6
import {
  Services,
  Portfolios,
  Advantages,
  Testimonials,
} from "json/landingPageData2";
import Header2 from "parts/Header2";
import Hero2 from "parts/Hero2";
import Service2 from "parts/Service2";
import Portfolio2 from "parts/Portfolio2";
import Advantage2 from "parts/Advantage2";
import Testimonial2 from "parts/Testimonial2";
import Discuss2 from "parts/Discuss2";
import Footer2 from "parts/Footer2";

const LandingPage2 = () => {
  const location = useLocation(); // Get current URL

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load

    // Scroll to section if there's a hash (e.g., #part2)
    if (location.hash) {
      setTimeout(() => {
        const section = document.querySelector(location.hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]); // Runs when location changes

  return (
    <>
      <Header2 />
      <Hero2 />
      <Service2 data={Services} />
      <Portfolio2 data={Portfolios} />
      <Advantage2 data={Advantages} />
      <Testimonial2 data={Testimonials} />
      <Discuss2 />
      <Footer2 />
    </>
  );
};

export default LandingPage2;
